// Accounts Module - Root Sagas
// This file aggregates all accounts-related sagas

import watchAccountsListSaga from './List/store/saga'
import watchAccountsFormSaga from './Form/store/saga'

// Root saga for Accounts module
export default [
  watchAccountsListSaga(),
  watchAccountsFormSaga(),
]

